import { ErrorHandler, Injectable, inject } from '@angular/core';
import { LogService } from '../log-service/log.service';

@Injectable()
export class CwrErrorHandler implements ErrorHandler {
  private readonly logService = inject(LogService);

  handleError(error: Error): void {
    this.logService.error('CwrErrorHandler.handleError', error, {
      uncaught: true,
    });
  }
}
